module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAABGdBTUEAALGPC/xhBQAAAV5JREFUOE+NlC22gzAQRvMcElmJRCKRlchKJEtA4pAsAYmsRCKR1CFZQiUSXHs5wxnyKOU0iiRz5+ebCX+v18scrXmeH48HN0EQuK57aGOA7fV8PpMk8X3ftvY8L47jYRh2xv/gpmkul8txEGMcxymKwuY3OE3THRaG4fV63R1GUTRNk7hY4bqu1YicScGO0HUdjtQgy7INpk7N9na7jeO4q022eZ4rj7s1MmLIKTE1pUNeLWnBCmvYtm0PGT0kR2STSCRo2MuGZp6TcqvFo4tRqRD2F1ibQtvM/X6XyEj1C4zUYr/o1/e9bBijX2BiiP0SFUA1oP5znl6oukzrAusY0YlzWFst6i4wHdLuk8w3nsHQHPGyjac92EjyOSpoqyQTIgbrbLOxnyHiIQzuYajFvsIFGm+zLV9MDC9Z8z/8wItM9R6W/bcnTcDPcvZ/EnFBYlVVkTarLEs7mi3nGzKtvdJmYPpfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Circle.png
// module id = 2PZ8
// module chunks = 1